import type {AnchorHTMLAttributes} from 'react';
import classNames from 'classnames';

import styles from './menu-item-anchor.module.css';

export const MenuItemAnchor = ({children, className, ...props}: AnchorHTMLAttributes<HTMLAnchorElement>) => (
    <a {...props} className={classNames(className, styles.anchor)}>
        {children}
    </a>
);
